module.exports = __webpack_public_path__ + "img/mobile_icon.dc6b728d.svg";